'use strict'

import ApiClient from './ApiClient'

export default class UserRepository {
  /**
   * ユーザー情報一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/users`, { params })
  }

  /**
   * 新しいユーザー情報を作成します。
   * @param {object} formData
   * @returns {*}
   */
  post (formData) {
    return ApiClient().post(`/users`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 指定されたIDのユーザー情報を取得します。
   * @param {string|int} id
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/users/${id}`)
  }

  /**
   * 指定されたIDのユーザー情報を更新します。
   * @param {string|int} id
   * @param {object} formData
   * @returns {*}
   */
  put (id, formData) {
    formData.append('_method', 'PUT')

    return ApiClient().post(`/users/${id}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 指定されたIDのユーザー情報を物理削除します。
   * @param {string|int} id
   * @returns {*}
   */
  physicalDelete (id) {
    return ApiClient().delete(`/users/${id}`)
  }

  /**
   * 指定されたIDのユーザー情報を論理削除します。
   * @param {string|int} id
   * @returns {*}
   */
  logicalDelete (id) {
    return ApiClient().put(`/users/logical-delete/${id}`)
  }

  /**
   * 指定された複数IDのユーザー情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/users/delete`, data)
  }

  /**
   * 指定された複数IDのユーザー情報を一括で使用停止・再開します。
   * @param {object} data
   * @returns {*}
   */
  changeStatus (data) {
    return ApiClient().post(`/users/state`, data)
  }

  /**
   * 指定された複数IDのユーザー情報を一括でログイン拒否解除します。
   * @param {object} data
   * @returns {*}
   */
  resetLogin (data) {
    return ApiClient().post(`/users/login-reset`, data)
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します。
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/users/sort`, params)
  }

  /**
   * ユーザー名刺画像を取得します。
   * @param {string|int} ユーザーID
   * @returns {*}
   */
  images (user_id) {
    return ApiClient().get(`/users/${user_id}/images`)
  }

  /**
   * 指定されたIDのユーザー情報を取得します（プロフィール用）。
   * @param {string|int} user_id ユーザーID
   * @returns {*}
   */
  profile (user_id) {
    return ApiClient().get(`/users/profile/${user_id}`)
  }

  /**
   * ユーザー情報をCSVファイルにエクスポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postExport (formData) {
    return ApiClient().post(`/users/export`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * ユーザー情報エクスポートファイルをダウンロードします。
   * @param {object} options
   * @returns {*}
   */
  getExport (options) {
    return ApiClient().get(`/users/export`, options)
  }

  /**
   * ユーザー情報エクスポートの処理結果を取得する。
   * @returns {*}
   */
  getExportResult () {
    return ApiClient().get(`/users/export-result`)
  }

  /**
   * ユーザー情報エクスポートを停止する。（キャンセルファイルを作成する。）
   * @returns {*}
   */
  cancelExport () {
    return ApiClient().post(`/users/export-cancel`)
  }

  /**
   * ユーザー情報のCSVファイルをインポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  import (formData) {
    return ApiClient().post(`/users/import`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * ユーザー情報インポートの処理結果を取得する。
   * @returns {*}
   */
  getImportResult () {
    return ApiClient().get(`/users/import-result`)
  }

  /**
   * 検索条件に合致するユーザー情報一覧を取得します。
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  postSearch (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }
    delete data.page
    delete data.sort_item
    delete data.direction

    return ApiClient().post(`/users/search`, data, { params })
  }

  /**
   * 検索条件に合致するユーザー情報一覧を取得します。非表示ユーザーも取得します。
   * @param {object} data 検索条件のbody情報
   *    page {integer}
   *    sort_item {string}
   *    direction {string}
   *    ---
   *    group {integer}
   *    ids {array}
   *    name {string}
   *    mail {string}
   * @returns {*}
   */
  postSearchAll (data) {
    // クエリで指定するデータを移動する
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction,
      get_dels: '1' // 非表示ユーザーも取得するために固定
    }
    delete data.page
    delete data.sort_item
    delete data.direction

    return ApiClient().post(`/users/search`, data, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/UserRepository.js